module.exports = __webpack_public_path__ + "img/shili2.f6a5c582.png";